module.exports = ['computer', 'trello', 'link', 'google-drive', 'dropbox', 'box', 'onedrive']


// WEBPACK FOOTER //
// ./app/scripts/data/attachment-types.coffee